import React, {FC} from 'react';
import styled from 'styled-components';

import {Skeleton} from '../../../common/skeleton';

/*
 * Style.
 */

const StyledSkeletonSwitcherItemDiv = styled.div`
  display: flex;
  flex-flow: column;
  width: 43px;
`;
const StyledCircleSkeletonDiv = styled.div`
  width: 30px;
  height: 30px;
  border-radius: 50%;
  overflow: hidden;
  box-sizing: border-box;
  margin: auto;
`;

const StyledLineSkeletonDiv = styled.div`
  align-items: center;
`;

/*
 * Component.
 */

export const SkeletonSwitcherItem: FC = () => (
  <StyledSkeletonSwitcherItemDiv>
    <StyledCircleSkeletonDiv>
      <Skeleton width="30px" height="30px" />
    </StyledCircleSkeletonDiv>
    <StyledLineSkeletonDiv>
      <Skeleton height="7px" />
    </StyledLineSkeletonDiv>
  </StyledSkeletonSwitcherItemDiv>
);
